import React from 'react';

export default React.forwardRef(function TableTooltip({ children, visible, ...props }, ref) {
    return (
        visible && (
            <div
                ref={ref}
                {...props}
                className="tw-flex tw-flex-col tw-gap-y-2 tw-bg-white tw-p-3 tw-rounded-lg tw-border-2 tw-border-charcoal-50 tw-opacity-90 tw-w-max tw-z-[999]"
                role="tooltip"
            >
                <div className="tw-p-0 tw-bg-transparent" dangerouslySetInnerHTML={{ __html: children }}></div>
            </div>
        )
    );
});
